<template>
  <div>
    <modal
      :show.sync="modals.errorSavingItinerary"
      headerClasses="justify-content-center"
      @close="modals.errorSavingItinerary = false"
    >
      <h4 slot="header" class="title title-up text-center">Errore!</h4>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <h6 class="itineraryCode">
                Si è verificato un errore durante il salvataggio dell'itinerario
                sul server. Si prega di contattare l'assistenza.
              </h6>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <Button
          size="small"
          type="danger"
          v-on:click="modals.errorSavingItinerary = false"
          class="mx-1"
          >Chiudi
        </Button>
      </template>
    </modal>

    <modal
      :show.sync="modals.errorUnassignedPresent"
      headerClasses="justify-content-center"
      @close="modals.errorUnassignedPresent = false"
    >
      <h4 slot="header" class="title title-up text-center">Attenzione!</h4>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <h6 class="itineraryCode mb-4">
                Le seguenti attività non sono state inserite nell'itinerario per
                motivi di tempo.
              </h6>
              <div
                v-for="(notAssigned, index) in this.visualUnassigned"
                :key="index"
              >
                <div class="row">
                  <div class="col-12 col-lg-6 text-center">
                    {{ notAssigned.areaName }}
                  </div>

                  <div class="col-12 col-lg-4 text-center">
                    {{ notAssigned.activityName }}
                  </div>
                  <div class="col-12 col-lg-2 text-center">
                    {{ notAssigned.durata }} minuti
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <Button
          size="small"
          type="danger"
          v-on:click="modals.errorUnassignedPresent = false"
          class="mx-1"
          >Chiudi
        </Button>
      </template>
    </modal>

    <modal
      :show.sync="modals.askQuestionModal"
      headerClasses="justify-content-center"
      @close="modals.askQuestionModal = false"
    >
      <h4 slot="header" class="title title-up text-center">
        VALUTA LA TUA ESPERIENZA NEL CREARE L’ITINERARIO
      </h4>
      <div class="row">
        <div class="col-12">
          <div
            class="row mb-4"
            v-for="(question, index) in questions"
            :key="'question' + index"
          >
            <div class="col-12 text-center px-0">
              <div class="row">
                <div class="col-12 text-center">
                  <b class="itineraryCode">{{ question.question }}</b>
                  <h6 class="responseError" v-if="question.responseError">
                    Inserisci un valore per questa risposta
                  </h6>
                </div>
              </div>
              <div
                class="mx-auto row"
                :class="question.responseError ? 'responseError' : 'responseOk'"
              >
                <n-radio
                  v-for="response in question.response"
                  :key="response"
                  v-model="question.selectedResponse"
                  :label="response"
                  class="mx-auto"
                  @input="question.responseError = false"
                >
                  {{ response }}
                </n-radio>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <Button
          size="small"
          type="danger"
          v-on:click="modals.askQuestionModal = false"
          class="mx-1"
          >Chiudi
        </Button>
        <Button
          size="small"
          type="primary"
          v-on:click="bookItinerary()"
          class="mx-1"
          >Prenota Itinerario
        </Button>
      </template>
    </modal>

    <modal
      :show.sync="modals.errorSavingValutation"
      headerClasses="justify-content-center"
      @close="modals.errorSavingValutation = false"
    >
      <h4 slot="header" class="title title-up text-center">Errore!</h4>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <h6 class="itineraryCode">
                Si è verificato un errore durante il salvataggio delle risposte
                alla valutazione sul server. Si prega di contattare
                l'assistenza.
              </h6>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <Button
          size="small"
          type="danger"
          v-on:click="modals.errorSavingValutation = false"
          class="mx-1"
          >Chiudi
        </Button>
      </template>
    </modal>

    <modal
      :show.sync="modals.thanksForValutation"
      headerClasses="justify-content-center"
      @close="modals.thanksForValutation = false"
    >
      <h4 slot="header" class="title title-up text-center">
        Grazie per la tua valutazione!
      </h4>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <h6 class="itineraryCode">
                Ti ringraziamo per averci fornito il tuo feedback.
              </h6>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <Button
          size="small"
          type="danger"
          v-on:click="modals.thanksForValutation = false"
          class="mx-1"
          >Chiudi
        </Button>
      </template>
    </modal>
  </div>
</template>
  
<script>
const Common = require("@/Common.vue").default;

import $ from "jquery";

import { isMobile } from "mobile-device-detect";
// import { config } from "../../utils/config";
import { Radio, Modal, Switch } from "../../../components";
import { Button } from "element-ui";


export default {
  name: "modal-sintesi-itinerario",
  props: ["modals", "visualUnassigned"],

  components: {
    Modal,
    [Radio.name]: Radio,
    Button
  },

  data() {
    return {
      selectedTab: "Panoramica",
      windowWidth: 0,
      isLoadingImages: true,
      isLoadingVideos: true,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      isMobile: false,
      isGeodidalab: false,



      questions: [
        {
          question:
            "Quanto l’applicazione che hai usato ti è stata utile nel supportarti come docente nell’organizzazione di una gita scolastica tipo esperienziale?",
          response: ["1", "2", "3", "4", "5"],
          selectedResponse: "",
          responseError: false,
        },
        {
          question:
            "L’applicazione riesce a motivarti nell’organizzare il viaggio d’istruzione?",
          response: ["1", "2", "3", "4", "5"],
          selectedResponse: "",
          responseError: false,
        },
        {
          question: "Quanto è stato facile organizzare l’itinerario?",
          response: ["1", "2", "3", "4", "5"],
          selectedResponse: "",
          responseError: false,
        },
        {
          question:
            "Pensi che sapere quanto tempo ti rimane a disposizione sia utile nel pianificare la gita e le attività?",
          response: ["1", "2", "3", "4", "5"],
          selectedResponse: "",
          responseError: false,
        },
      ],

    };
  },
  created() {
    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    // this.isGeodidalab = config.isGeodidalab;
  },

  methods: {
    bookItinerary(){
      console.log("EMITTO BOOK ITINERARY");
      console.log("DOMANDE");
      console.log(this.questions);
      this.$emit('bookItinerary', this.questions);
    }
  },
  computed: {
    
  },

  mounted() {
    this.isMobile = isMobile;

    var self = this;
  },
};
</script>
  
  <style lang="scss">
</style>